import { useState } from 'react';

import { useSnackbar } from 'notistack';

import { useExportLensPdf } from '~/hooks/apis/reporting/useExportLensPdf';

import { downloadLensCsv } from '~/utils/downloadLensCsv';

import type { LensState } from './types';

export type LensDownloadOptions = {
  lensId: string;
  lensVersion?: number;
  title: string;
  state: LensState;
  blocks: Array<string>;
  tabs?: Array<string>;
};

export default function useLensDownloads({ lensId, lensVersion, title, state, blocks, tabs }: LensDownloadOptions) {
  const [csvPending, setCsvPending] = useState(false);
  const exportPdf = useExportLensPdf(lensId);
  const { enqueueSnackbar } = useSnackbar();

  return {
    pending: exportPdf.isPending || csvPending,
    pdfError: exportPdf.isError,
    pdf: () => exportPdf.mutate({ state, title, lensVersion }),
    csv: () => {
      setCsvPending(true);
      downloadLensCsv(lensId, { state, blocks, tabs, lensVersion })
        .catch(() => enqueueSnackbar('The CSV didn’t download. Try again.', { variant: 'warning' }))
        .finally(() => setCsvPending(false));
    },
  };
}
